


















































import Vue from "vue";
import moment from "moment";

// vuex
import { mapActions, mapGetters, mapState } from "vuex";
import { RootState } from "@/store";
import * as a from "@/store/modules/InstallationsWorkloadModule/actions";

// model
import { GetWorkloadReqData } from "@/model/communication/workload/GetWorkloadReqData";

export default Vue.extend({
    data() {
        return {
            moment,
            filters: {
                startDate: null,
                endDate: null,
                currency: null,
            },
            startDatePicker: null,
            endDatePicker: null,
            radioSelection: null,
            currentReqData: new GetWorkloadReqData(null),
            defaultDateRanges: [
                {
                    id: "lastMonth",
                    i18nLabel: "workloadReport.lastMonth",
                    value: 0,
                },
                {
                    id: "last3Months",
                    i18nLabel: "workloadReport.last3Months",
                    value: 1,
                },
                {
                    id: "last6Months",
                    i18nLabel: "workloadReport.last6Months",
                    value: 2,
                },
                {
                    id: "customDateRange",
                    i18nLabel: "",
                    value: 3,
                },
            ],
            currencySelected: "",
        };
    },
    computed: {
        ...mapState({
            currencies: (state: RootState): string[] => state.installationWorkload.currencies,
            isInstallationsListFetching: (state: RootState): boolean => state.installationWorkload.isInstallationsListFetching,
        }),
        ...mapGetters(["userDateFormat"]),
        dateRangeFormatted() {
            if (this.dateRange == null || this.dateRange == undefined || this.dateRange.length == 0) return this.dateRange;
            let dateRangeString = "";
            this.dateRange.forEach((date) => {
                dateRangeString += moment(date).format(this.userDateFormat) + ",";
            });
            return dateRangeString.slice(0, -1);
        },
        canSubmit() {
            return (this.radioSelection != 3 || this.dateRange.length == 2) && !this.isInstallationsListFetching;
        },
        dateRange: {
            get() {
                let res = [];
                if (this.startDatePicker) res.push(this.startDatePicker.toISOString().substr(0, 10));
                if (this.endDatePicker) res.push(this.endDatePicker.toISOString().substr(0, 10));
                return res;
            },
            set(v: number[]) {
                if (v.length == 1) {
                    this.startDatePicker = new Date(v[0]);
                    this.endDatePicker = null;
                } else {
                    const a = new Date(v[0]);
                    const b = new Date(v[1]);
                    if (a < b) {
                        this.startDatePicker = a;
                        this.endDatePicker = b;
                    } else {
                        this.startDatePicker = b;
                        this.endDatePicker = a;
                    }

                    this.endDatePicker.setUTCHours(23);
                    this.endDatePicker.setUTCMinutes(59);
                    this.endDatePicker.setUTCSeconds(59);

                    this.filters.startDate = this.startDatePicker as Date;
                    this.filters.endDate = this.endDatePicker as Date;
                }
            },
        },
    },
    watch: {
        radioSelection(value) {
            let startDateTemp = null;
            let endDateTemp = new Date();

            if (value != 3) {
                this.startDatePicker = null;
                this.endDatePicker = null;
            }

            switch (value) {
                case 0:
                    startDateTemp = moment().subtract(1, "months").utc();
                    break;
                case 1:
                    startDateTemp = moment().subtract(3, "months").utc();
                    break;
                case 2:
                    startDateTemp = moment().subtract(6, "months").utc();
                    break;

                default:
                    break;
            }

            this.filters.startDate = startDateTemp as Date;
            this.filters.endDate = endDateTemp as Date;
        },
        currencySelected(value) {
            this.filters.currency = value;
        },
    },
    methods: {
        ...mapActions([a.GET_WORKLOAD_CURRENCIES]),

        submit() {
            this.$emit("submit-event", this.filters);
        },
    },
    async mounted() {
        await this[a.GET_WORKLOAD_CURRENCIES]();
        this.radioSelection = 0;
        this.currencySelected = this.currencies[0];
    },
});
